/* eslint-disable quote-props */
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import * as playerEventsActions from './actions/player-events';

const EVENT_TO_ACTION = {
  'preflight': playerEventsActions.preflight,
  'viewable': playerEventsActions.viewable,
  'playing': playerEventsActions.playing,
  'pause': playerEventsActions.pause,
  'streamEnded': playerEventsActions.streamEnded,
  'destroy': playerEventsActions.destroy,
  'fullscreen': playerEventsActions.fullscreen,
  'playerInitialized': playerEventsActions.initialized,
  'offsetFromLive': playerEventsActions.offsetFromLive,
  'ontimeupdate': playerEventsActions.timeupdate,
  'chromecastOntimeupdate': playerEventsActions.chromecastTimeupdate,
  'buffering': playerEventsActions.buffering,
  'volumechange': playerEventsActions.volumeChange,
  'ontimeupdateads': playerEventsActions.adsTimeupdate,
  'ischromecastavailable': playerEventsActions.chromecastAvailable,
  'isairplayavailable': playerEventsActions.airplayAvailable,
  'isairplaying': playerEventsActions.airplaying,
  'chromecastActivated': playerEventsActions.chromecastActivated,
  'chromecastDeactivated': playerEventsActions.chromecastDeactivated,
  'adsPlaying': playerEventsActions.adsPlaying,
  'adsPause': playerEventsActions.adsPause,
  'adsEnded': playerEventsActions.adsEnded,
  'adsDeactivated': playerEventsActions.adsDeactivated,
  'error': playerEventsActions.error,
  'entitlement': playerEventsActions.entitlement,
  'entitlement:incorrect-pincode': playerEventsActions.pincodeIncorrect,
  'entitlement:required-pincode': playerEventsActions.pincodeRequired,
  'dai:playing': playerEventsActions.daiAdsPlaying,
  'dai:ended': playerEventsActions.daiAdsEnded,
};

function SyncPlayerState({ player }) {
  const dispatch = useDispatch();

  React.useEffect(() => {
    const unsub = [];

    for (const [eventName, action] of Object.entries(EVENT_TO_ACTION)) {
      const handler = event => dispatch(action(player, event));

      player.addEventListener(eventName, handler);

      unsub.push(() => player.removeEventListener(eventName, handler));
    }

    return () => {
      for (const unsubHandler of unsub) {
        unsubHandler();
      }
    };
  }, []);

  return null;
}

SyncPlayerState.propTypes = {
  player: PropTypes.object.isRequired,
};

export default React.memo(SyncPlayerState);
